export default __webpack_public_path__ + "static/media/syncIcon.ff82b13f.svg";